// `video.reference`: live's reference to video (G6, #203): reference images, and frames where the block takes them.
// The composer reaches it by its inputs (`video/modes.ts`, live's narrowing), never as a
// type to pick; dropping its references turns it back to text to video.
import { VideoReferenceQuote, VideoReferenceRequest } from "../../../api/generated/zod";
import type { JobTypeModule } from "./contract";
import { assetRefOf, commonFields, elementsOf, everyShotWritten, videoFields } from "./shared";

export const jobType: JobTypeModule<"video.reference"> = {
  type: "video.reference",
  label: "Reference-to-Video",
  source: "form",
  pair: "video.text",
  fields: (draft, advanced) => ({
    ...commonFields(draft),
    ...videoFields(draft, advanced),
    reference_images: draft.references,
    ...(draft.videos.length === 0
      ? {}
      : { reference_videos: draft.videos.map((video) => assetRefOf(video)) }),
    ...(draft.audios.length === 0
      ? {}
      : { reference_audios: draft.audios.map((audio) => assetRefOf(audio)) }),
    ...(draft.source === null ? {} : { start_frame: draft.source }),
    ...(draft.endFrame === null ? {} : { end_frame: draft.endFrame }),
    // Kling 4.0's keyframes between the frames, in order (spec web/keyframes-slot).
    ...(draft.middleFrames.length === 0
      ? {}
      : { middle_frames: draft.middleFrames.map((frame) => assetRefOf(frame)) }),
    ...elementsOf(draft),
    // Kling 4.0's voice profiles, in their `@Voice1` order (spec G2-kling-v4-voices).
    ...(draft.voices.length === 0 ? {} : { voices: draft.voices }),
  }),
  request: VideoReferenceRequest.refine(everyShotWritten),
  quote: VideoReferenceQuote,
};
